import React from 'react';

const sectionStyle = {
    maxWidth: 600,
    margin: '32px auto',
    background: '#fff',
    borderRadius: 16,
    boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
    padding: '32px 20px',
    fontFamily: 'inherit',
    color: '#222',
};
const h1Style = {
    fontSize: 28,
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: 32,
    letterSpacing: '-1px',
};
const h2Style = {
    fontSize: 20,
    fontWeight: 600,
    margin: '32px 0 12px 0',
    color: '#1a73e8',
};
const articleStyle = {
    fontSize: 16,
    lineHeight: 1.8,
    marginBottom: 18,
};
const strongStyle = { color: '#1a73e8', fontWeight: 600 };

const MarketingConsent = () => (
    <section style={sectionStyle}>
        <h1 style={h1Style}>마케팅 활용동의 및 광고 수신 동의서</h1>
        <article style={articleStyle}>
            Tobe Labs(이하 '회사'라고 합니다)는 개인정보보호법 등 관련 법령상의 개인정보보호 규정을 준수하며 회원의 개인정보보호에 최선을 다하고 있습니다. 회사는 개인정보보호법에 근거하여 다음과 같은 내용으로 마케팅 활용 및 광고 수신에 관한 동의를 받고자 합니다.<br /><br />
            다음의 내용을 자세히 읽어보시고 모든 내용을 이해하신 후에 동의 여부를 결정해주시기 바랍니다.
        </article>
        <article style={articleStyle}>
            <h2 style={h2Style}>제1조 <span style={strongStyle}>(마케팅 활용 동의)</span></h2>
            회사는 회원에게 더 나은 서비스를 제공하고 맞춤형 정보를 제공하기 위해 다음과 같은 목적으로 개인정보를 활용합니다.<br />
            <span style={strongStyle}>[활용 목적]</span> : 서비스 개선, 맞춤형 콘텐츠 제공, 신규 서비스 개발, 이벤트 및 프로모션 안내<br />
            <span style={strongStyle}>[활용 정보]</span> : 서비스 이용 기록, 투자 성향 정보, 관심 종목 정보, 앱 사용 패턴
        </article>
        <article style={articleStyle}>
            <h2 style={h2Style}>제2조 <span style={strongStyle}>(광고 수신 동의)</span></h2>
            회사는 회원에게 유용한 투자 정보와 서비스 관련 광고를 제공하기 위해 다음과 같은 방법으로 광고를 발송합니다.<br />
            <span style={strongStyle}>[광고 발송 방법]</span> : 푸시 알림, 이메일, 앱 내 알림<br />
            <span style={strongStyle}>[광고 내용]</span> : 투자 관련 정보, 신규 기능 안내, 이벤트 및 프로모션, 파트너사 서비스 안내
        </article>
        <article style={articleStyle}>
            <h2 style={h2Style}>제3조 <span style={strongStyle}>(개인정보 보유 및 이용 기간)</span></h2>
            <ol style={{ paddingLeft: 20 }}>
                <li>1. 마케팅 활용 및 광고 수신을 위한 개인정보는 동의일로부터 회원탈퇴시까지 보관 및 이용합니다.</li>
                <li>2. 회원이 동의를 철회하는 경우, 지체없이 해당 개인정보의 마케팅 활용을 중단합니다.</li>
                <li>3. 개인정보 보유기간의 경과, 처리목적의 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</li>
            </ol>
        </article>
        <article style={articleStyle}>
            <h2 style={h2Style}>제4조 <span style={strongStyle}>(동의 거부 관리)</span></h2>
            귀하는 본 안내에 따른 마케팅 활용 및 광고 수신에 대하여 동의를 거부할 권리가 있습니다. 다만, 귀하가 동의를 거부하시는 경우에 다음과 같은 불이익이 발생할 수 있음을 알려드립니다.<br />
            <ol style={{ paddingLeft: 20 }}>
                <li>• 맞춤형 투자 정보 및 서비스 추천 기능 제한</li>
                <li>• 이벤트 및 프로모션 정보 수신 불가</li>
                <li>• 신규 기능 및 서비스 업데이트 정보 수신 불가</li>
            </ol>
        </article>
        <article style={articleStyle}>
            <h2 style={h2Style}>제5조 <span style={strongStyle}>(동의 철회 방법)</span></h2>
            회원은 언제든지 마케팅 활용 및 광고 수신 동의를 철회할 수 있습니다.<br />
            <span style={strongStyle}>[동의 철회 방법]</span> : 앱 설정 {'>'}{' '}알림 설정에서 개별적으로 관리 가능
        </article>
        <article style={articleStyle}>
            <h2 style={h2Style}>제6조 <span style={strongStyle}>(개인정보의 제3자 제공)</span></h2>
            회사는 마케팅 활용 및 광고 수신을 위해 다음과 같은 제3자에게 개인정보를 제공할 수 있습니다.<br />
            <ol style={{ paddingLeft: 20 }}>
                <li>1. 개인정보를 제공 받는 제3자 : 광고 대행사, 분석 서비스 제공업체</li>
                <li>2. 개인정보 제공 목적 : 맞춤형 광고 제공, 서비스 이용 분석</li>
                <li>3. 개인정보 제공 항목 : 서비스 이용 기록, 관심 종목 정보, 앱 사용 패턴</li>
                <li>4. 개인정보 보유 및 이용기간 : 개인정보 제공 목적 달성일까지</li>
                <li>5. 개인정보 제공 거부 시 불이익 : 맞춤형 서비스 제공 제한</li>
            </ol>
        </article>
        <article style={articleStyle}>
            본인은 위의 동의서 내용을 충분히 숙지하였으며, 위와 같이 개인정보를 마케팅 활용 및 광고 수신 목적으로 처리하는데 동의합니다.<br /><br />
            그 외 사항은 회사의 개인정보처리방침에 따릅니다.
        </article>
        <div style={{ textAlign: 'right', marginTop: 40, color: '#888', fontSize: 15 }}>
            2025.07.22.
        </div>
    </section>
);

export default MarketingConsent; 